import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {assignedUsersStateSelector} from './assigned-users-state-slice';

import type {AssignedUsersFilters, AssignedUsersSearchCriteria} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AdminSortField} from 'src/openapi/admin/models/AdminSortField';
import type {AdminUser} from 'src/openapi/admin/models/AdminUser';


export const assignedUsersSlice = getCachedTableDataSlice<
    AdminUser[],
    AssignedUsersSearchCriteria,
    AdminSortField,
    AssignedUsersFilters
>('roleAssignedUsers');

export const assignedUsersActions = assignedUsersSlice.actions;
export const assignedUsersCacheSelector: CachedTableCacheSelector<AdminUser[]>
    = state => state.adminRights.assignedUsers.result.cache;
export const assignedUsersDataSelector: CachedTableDataSelector<AdminUser[]>
    = state => state.adminRights.assignedUsers.result;
export const assignedUsersResultSelector = getCachedTableResultSelector(
    assignedUsersCacheSelector,
    assignedUsersStateSelector,
);
